module.exports = __webpack_public_path__ + "img/icon-更多@2x.21f974a9.png";